import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

const selectors = {
  slider: '[data-slider]',
};

const sectionType = 'trust-indicators';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;
      const sectionSettings = container.dataset.sectionSettings || '{}';
      this.settings = JSON.parse(sectionSettings);
      const autoPlaySpeed = Number(this.settings.autoplay_speed * 1000);

      const slider = container.querySelector(selectors.slider);
      if (!slider) return;

      // eslint-disable-next-line no-unused-vars
      const flickity = new Flickity(slider, {
        // options
        autoPlay: autoPlaySpeed,
        prevNextButtons: false,
        pageDots: false,
        setGallerySize: true,
        watchCSS: true,
        wrapAround: true,
        contain: true,
      });
    },
  });
